document.addEventListener('DOMContentLoaded', function () {
  const select = document.getElementById('flavor-select');
  if (!select) return;

  // Injecte les couleurs dans customProperties en tant que chaîne JSON
  Array.from(select.options).forEach(option => {
    const color = option.dataset.color;
    if (color) {
      option.dataset.customProperties = JSON.stringify({ color: color });
    }
  });

  const tomSelectInstance = new TomSelect(select, {
    controlInput: false, // 👈 désactive le champ de saisie
    onChange: function(value) {
      const selectedOption = select.options[select.selectedIndex];
      const url = selectedOption.dataset.url;
      if (url) {
        window.location.href = url;
      }
    },
    render: {
      option: function(data, escape) {
        let color = '#ccc';
        if (data.customProperties) {
          try {
            const props = typeof data.customProperties === 'string' ? JSON.parse(data.customProperties) : data.customProperties;
            if (props.color) color = props.color;
          } catch(e) {}
        }

        const textParts = data.text.trim().split(' ');
        const first = escape(textParts.shift() || '');
        const rest = escape(textParts.join(' '));

        return `<div class="ts-option-item">
                  <span class="flavor-dot" style="background-color:${color}"></span>
                  <span>${first} <strong>${rest}</strong></span>
                </div>`;
      },

      item: function(data, escape) {
        let color = '#ccc';
        if (data.customProperties) {
          try {
            const props = typeof data.customProperties === 'string' ? JSON.parse(data.customProperties) : data.customProperties;
            if (props.color) color = props.color;
          } catch(e) {}
        }

        const textParts = data.text.trim().split(' ');
        const first = escape(textParts.shift() || '');
        const rest = escape(textParts.join(' '));

        return `<div class="ts-option-item selected">
                  <span class="flavor-dot" style="background-color:${color}"></span>
                  <span>${first} <strong>${rest}</strong></span>
                </div>`;
      }
    }
  });

});
